import React,{useEffect} from "react";
import { createContext, useContext } from "react";

export const userSessionContext = createContext({
  user: null,
  logIn: () => {},
  logOut: () => {},
});

export function useUserSession() {
  const { user, logIn, logOut } = useContext(userSessionContext);
  
  useEffect(() => {
    const us=JSON.parse(localStorage.getItem("user"))  
    if(us===null)
   { 
    localStorage.setItem("user",JSON.stringify(user))      
 }
 else if(us!==null && !us.Islogin)
   { localStorage.setItem("user",JSON.stringify(user))      
 }
  }, [user]);

  return { user, logIn, logOut };
}
